








import {Component, Provide, Vue} from 'vue-property-decorator';
// import HeaderComponent from '../../components/common/HeaderClosed.vue';
@Component({
    // components: { HeaderComponent },
})
export default class Desktop extends Vue { }
